module.exports = __webpack_public_path__ + "static/media/paymaster.0ed5a66c.png";